module.exports = __webpack_public_path__ + "img/tit3.c7d51e8e.png";